import React from "react";
import { Icon } from "@iconify/react";

const BadGuyIcon = () => (
  <Icon icon="lucide:swords" width={18} height={18} />
);

export default BadGuyIcon;
